/** Seller store URL, falling back to the listing URL when Amazon-style rows only have a name. */
export function resolveSellerInjectUrl(seller: any, product: any): string {
  return String(
    seller?.url ||
      seller?.store_url ||
      seller?.seller_store_url ||
      product?.seller_store_url ||
      product?.sellerStoreUrl ||
      product?.url ||
      ''
  ).trim();
}

export function resolveSellerMarketplace(
  listingPlatform?: string | null,
  storePlatform?: string | null,
  productMarketplace?: string | null
): string {
  return String(listingPlatform || storePlatform || productMarketplace || '').trim();
}
